import React from "react";
import {arrowPlacementClasses} from "./CommonReact";
import {enumOutClickModes} from "./UIPopPanel";

let ctrl;  // Registered by App.jsx at startup via registerTooltipCtrl().

export const registerTooltipCtrl = c => ctrl = c;

const setTooltip = prop => ctrl.set(old => ({...old, ...prop}));
export const isTooltipOn = () => ctrl.isShown();

export const showTooltip = ({rAnchor, tip, opts, delay}) => {
    clearTimeout(ctrl.tmr);
    if (rAnchor)
        ctrl.tmr = setTimeout(() => {
            if (rAnchor instanceof Element && !document.body.contains(rAnchor)) return;
            setTooltip({show: true, rAnchor, transition: true, children: tip, align: "below left", ...opts});
        }, delay || 0);
};

export const hideTooltip = () => {
    clearTimeout(ctrl.tmr);
    ctrl.tmr = setTimeout(() => setTooltip({show: false}), 600);
};

const onMouseEnterTip = (e, tip, side, extraOpts) => {
    const tipVal = typeof tip === "function" ? tip() : tip;
    showTooltip({
        rAnchor: e.target,
        tip: <div
            data-test="gen-tool-tip" className={`after:border-b-popup bg-popup ${typeof tipVal === "string" && "max-w-[22rem] whitespace-pre-line [word-break:break-word]"} ${
                arrowPlacementClasses[side || "left"]}`}>{tipVal}</div>,
        opts: {margin: 10, outClickMode: enumOutClickModes.propagate, ...extraOpts},
        delay: 400
    });
};

export const genTooltip = (tip, side, opts) => !tip ? {} : {
    onMouseEnter: e => onMouseEnterTip(e, tip, side, opts),
    onMouseLeave: hideTooltip
};

export const genTooltipIfClamped = (tip, side, opts) => ({
    onMouseEnter: e => { const el = e.currentTarget; if (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) onMouseEnterTip(e, tip, side, opts); },
    onMouseLeave: hideTooltip
});
